import { defineStore } from 'pinia'
import type { ITerms, ITermsParams } from '@ui/interfaces/terms'
import { getDataLang } from '../helpers/api'

const DATA = {
  term_condition_id: '',
  title: '',
  description: '',
  category: '',
  slug: '',
  general_terms: false,
  image_url: '',
}
export interface TermsState {
  list: ITerms[]
  terms: Array<ITermsParams>
  generalTerms: Array<ITermsParams>
  detail: any
}

export const useTermsStore = defineStore('terms', {
  state: (): TermsState => ({
    list: [],
    terms: [],
    generalTerms: [],
    detail: {},
  }),
  getters: {
    getList(): TermsState['list'] {
      return getDataLang(this.list)
    },
    getListTerms(): TermsState['terms'] {
      return getDataLang(this.terms)
    },
    getGeneralTerms(): TermsState['generalTerms'] {
      return getDataLang(this.generalTerms)
    },
    getDetail(): TermsState['detail'] {
      return getDataLang(this.detail)
    },
    getTerms(state): any {
      const list = getDataLang(state.list)
      return (slug: string) => Array.isArray(list)
        && list.length
        ? list.find((el: any) => el.slug === slug)
        : DATA
    },
  },
  actions: {
    setList(data: ITerms[]) {
      const tmp = getDataLang(data)
      const listGeneral = []
      const listTerms = []
      if (tmp && tmp.length) {
        for (let i = 0; i < tmp.length; i++) {
          const el = tmp[i]
          if (el?.general_terms)
            listGeneral.push(el)
          else if (el)
            listTerms.push(el)
        }
      }
      this.setGeneralTerms(listGeneral)
      this.setTerms(listTerms)
      this.list = data
    },
    setDetail(data: ITerms) {
      this.detail = data
    },
    setTerms(data: ITermsParams[]) {
      this.terms = data
    },
    setGeneralTerms(data: ITermsParams[]) {
      this.generalTerms = data
    },
  },
})
